import { Box, SxProps, Theme } from "@mui/material";

// Identity colour of an option (a model, a family…), shown raw as a small
// tile: never converted for the theme, the colour is the option's label.
const ColorSwatch = ({
  color,
  size = 20,
  sx,
}: {
  color: string;
  size?: number;
  sx?: SxProps<Theme>;
}) => (
  <Box
    component="span"
    sx={[
      {
        display: "inline-block",
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "4px",
        backgroundColor: color,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default ColorSwatch;
